import { AppDispatch } from "@Reducers/index";
import { getBackendUrl } from "@Utils";
import axiosWrapper from "@AxiosWrapper";
import type { CustomModuleControllerResponse, GetPortalProfilesResponse } from "@ServerTypes/portal/portal.schema";

import { setPortalProfilesAction as setPortalProfiles, setCustomModulesAction } from "../reducers/portalSetting";

export function getPortalCustomModules() {
  return async (dispatch: AppDispatch) => {
    const responseData = await axiosWrapper.post<CustomModuleControllerResponse>(
      `${getBackendUrl()}/portal/customModuleController`,
    );
    if (responseData.data.status) {
      dispatch(setCustomModulesAction(responseData.data.result));
    }
  };
}

export function getPortalProfiles() {
  return async (dispatch: AppDispatch) => {
    const responseData = await axiosWrapper.post<GetPortalProfilesResponse>(
      `${getBackendUrl()}/portal/getPortalProfiles`,
    );
    if (responseData.data.status) {
      dispatch(setPortalProfiles(responseData.data.result));
    }
  };
}
